export default __webpack_public_path__ + "static/media/29.f8bab003.png";